import { EditorialMessageContent } from "./EditorialMessageContent";
import { DataRelatedBuilder } from "./DataRelatedBuilder";
import { AuthorMini } from "../../shared/models/Author";
import { PostI3 } from "../../shared/models/postI3";
import { truncateSummary } from "../services/summary.service";
import { getImagePath } from "../utils/pathHelper";

export class WebinarDataRelatedBuilder implements DataRelatedBuilder <PostI3> {
  build(post: PostI3, content: EditorialMessageContent, author: AuthorMini): EditorialMessageContent {
    content.relatedWebinarContent = {
      EventPostId: post.id,
      EventPostUrl: post.url,
      FeedId: post.feedId,
      Title: post.title,
      PublicationDateUtc: post.publicationDate,
      Duration: post.videoDurationSeconds,
      AuthorName: author.Name,
      AuthorImageUrl: getImagePath(author.UrlPhoto, "XtraSmall"),
      Summary: truncateSummary(post.summary),
      IsPremium: post.isPremium
    }
    content.relatedRecordingContent = null;
    content.relatedPostContent = null;
    content.relatedCalendarEventContent = null;
    
    return content;
  }
}




// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/WebinarDataRelatedBuilder.ts